import React, { useEffect, useState } from 'react'
import { MdDelete, MdEdit } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import { activeCoupon, getCoupon, updateCoupon } from '../logic/plans/action';

const Coupons = () => {
    const dispatch = useDispatch(); 
    const selector = useSelector(state=>state.plans);
    const [open, setopen] = useState(false); 
    const [data, setdata] = useState({
        coupen_code:'',
        price:0,
        ispercent:0,
        id:0
    }); 
    useEffect(() => {
      getCoupon(dispatch);
    //   getPlan(dispatch);
    }, []);
    
  return (
    <AppLayout>
    <div className={`fixed top-0 left-0 w-screen h-screen bg-black/40 ${open?'flex':'hidden'} items-center justify-center`}>
    <div className='w-1/2 bg-white h-1/2 flex flex-col items-center gap-4 p-10 rounded-md'>
          <input placeholder='Coupon Code' 
          value={data.coupen_code}
          onChange={
            (e)=>{
                setdata(prev=>({...prev,coupen_code:e.target.value}))
            }
          }/>
          <input placeholder='Discount Price' 
          value={data.price}
          onChange={
            (e)=>{
                setdata(prev=>({...prev,price:e.target.value}))
            }
          }/>
          <select 
          value={data.ispercent}
          onChange={
            (e)=>{
                setdata(prev=>({...prev,ispercent:e.target.value}))
            }
          }
    className='h-10 outline-none rounded-md px-4 w-full border-blue-800 border' name="Type" id="Type" >
    {/* <option value={2} selected disabled>I</option> */}
    <option value={1} selected>%</option>
    <option value={0}>₹</option>
    
  </select>
          <button onClick={()=>{
            updateCoupon(dispatch,data);
            setopen(false)
          }
          }>Edit Discount</button>
          </div>
    </div>
    <div className="flex-1 h-full flex flex-col items-start gap-10 p-10 justify-center">
      <div className="flex justify-between w-full">
        <h1 className="font-bold text-2xl">Discounts</h1>
        <Link to={"/admin/coupons/add"}>
          <button className="w-12 h-12 rounded-full">+</button>
        </Link>
      </div>
      <div className="w-full h-[80%] flex flex-col shadow-lg gap-4">
          <div className="py-4 h-auto flex w-full bg-gray-500 text-white font bold">
            <p className="flex-1 text-center">Id</p>
            <p className="flex-1 text-center">Coupon Code</p>
            <p className="flex-1 text-center">Price</p>
            <p className="flex-1 text-center">Active</p>
            <p className="flex-1 text-center">Action</p>
          </div>
          <div className="flex-1 overflow-y-scroll">
            {
                selector?.coupons?.map(
                    (e,i)=><div className='py-4 flex w-full border-b-[0.1px] border-gray-500 font bold' key={i}>
                        <p className='flex-1 text-center capitalize'>{e?.id}</p>
                        <p className='flex-1 text-center capitalize'>{e?.coupen_code}</p>
                        <p className='flex-1 text-center capitalize'>{e?.ispercent === 0 ?'₹':''} {e?.price} {e?.ispercent === 0 ?'':'%'}</p>
                        <p className='flex-1 text-center capitalize'>
                          {/* {e?.active} */}
                          <input onChange={
                            (ev)=>
                                activeCoupon(dispatch,{id:e?.id,active:e?.active===1?0:1,})
                          } type="checkbox" checked={e?.active === 1}/>
                        </p>
                        <p className='flex-1 text-center capitalize flex items-center justify-center gap-2'>
                            <MdEdit onClick={
                                ()=>{
                                    setdata({
                                      id:e.id,
                                        coupen_code:e.coupen_code,
                                        price:e.price,
                                        ispercent:e.ispercent,
                                    });
                                    setopen(true);
                                }
                            }/>
                            <MdDelete color={'red'}/>
                        </p>
                    </div>
                )
            }
          </div>
          </div>
      </div>
    </AppLayout>
  )
}

export default Coupons;